<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <form class="relative sm:w-[265px]">
          <label
            class="leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2"
          >
            <i class="material-symbols-outlined !text-[20px]"> search </i>
          </label>
          <input
            type="text"
            v-model="searchTerm"
            :placeholder="directT('crm.deals.searchDeal')"
            class="bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          />
        </form>
      </div>
      <div class="trezo-card-subtitle mt-[15px] sm:mt-0">
        <button
          type="button"
          class="inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
          @click="stateStoreInstance.activeBtn"
        >
          <span class="inline-block relative ltr:pl-[22px] rtl:pr-[22px]">
            <i
              class="material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2"
            >
              add
            </i>
            {{ directT('crm.deals.addNewDeal') }}
          </span>
        </button>
      </div>
    </div>

    <div class="trezo-card-content -mx-[20px] md:-mx-[25px]">
      <div v-if="loading" class="flex justify-center items-center py-10">
        <div class="spinner"></div>
      </div>
      <div v-else-if="deals.length === 0" class="text-center py-10">
        <p class="text-gray-500 dark:text-gray-400">{{ directT('crm.deals.noDealsFound') }}</p>
        <div class="flex justify-center gap-4 mt-4">
          <button 
            @click="fetchAllDeals"
            class="px-4 py-2 bg-primary-500 text-white rounded-md"
          >
            {{ directT('crm.deals.tryAltLoading') }}
          </button>
          <button 
            @click="checkTablesAndDebugging"
            class="px-4 py-2 bg-blue-500 text-white rounded-md"
          >
            {{ directT('crm.deals.debugConnection') }}
          </button>
          <button 
            @click="createTestDeal"
            class="px-4 py-2 bg-green-500 text-white rounded-md"
          >
            {{ directT('crm.deals.createTestDeal') }}
          </button>
        </div>
      </div>
      <div v-else class="table-responsive overflow-x-auto">
        <table class="w-full">
          <thead class="text-black dark:text-white">
            <tr>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.id') }}
              </th>
              <th
                class="font-medium text-center px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.title') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.contactPerson') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.amount') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.createdAt') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.status') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('crm.deals.action') }}
              </th>
            </tr>
          </thead>
          <tbody class="text-black dark:text-white">
            <tr v-for="deal in filteredDeals" :key="deal.id">
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ shortId(deal.id) }}
                </span>
              </td>
              <td
                class="text-center whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">{{ deal.title }}</span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                {{ deal.first_name && deal.last_name ? `${deal.first_name} ${deal.last_name}` : (deal.name || directT('crm.deals.notDefined')) }}
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ formatCurrency(deal.amount) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ formatDate(deal.created_at) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span 
                  class="px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs"
                  :class="{
                    'bg-primary-50 dark:bg-[#15203c] text-primary-500': deal.status === 'new',
                    'bg-green-50 dark:bg-[#15203c] text-green-500': deal.status === 'in progress',
                    'bg-yellow-50 dark:bg-[#15203c] text-yellow-500': deal.status === 'negotiation',
                    'bg-blue-50 dark:bg-[#15203c] text-blue-500': deal.status === 'closed won',
                    'bg-red-50 dark:bg-[#15203c] text-red-500': deal.status === 'closed lost'
                  }"
                >
                  {{ getStatusText(deal.status) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap p-[20px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <div class="flex items-center gap-[9px]">
                  <button
                    type="button"
                    class="text-primary-500 leading-none custom-tooltip"
                    id="customTooltip"
                    :data-text="directT('crm.deals.view')"
                    @click="viewDeal(deal.id)"
                  >
                    <i class="material-symbols-outlined !text-md">
                      visibility
                    </i>
                  </button>
                  <button
                    type="button"
                    class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
                    id="customTooltip"
                    :data-text="directT('crm.deals.edit')"
                    @click="editDeal(deal.id)"
                  >
                    <i class="material-symbols-outlined !text-md"> edit </i>
                  </button>
                  <button
                    type="button"
                    class="text-danger-500 leading-none custom-tooltip"
                    id="customTooltip"
                    :data-text="directT('crm.deals.delete')"
                    @click="confirmDeleteDeal(deal.id)"
                  >
                    <i class="material-symbols-outlined !text-md"> delete </i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Pagination
        :items="10"
        :total="36"
        class="px-[20px] md:px-[25px] pt-[12px] md:pt-[14px]"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import stateStore from "@/utils/store";
import { supabase } from '@/lib/supabaseClient';
import { createToast } from '@/utils/toast';
import Pagination from "@/components/Common/Pagination.vue";
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import enTranslations from '@/i18n/locales/en.json';
import heTranslations from '@/i18n/locales/he.json';
import arTranslations from '@/i18n/locales/ar.json';

type TranslationObject = Record<string, any>;

interface Deal {
  id: string;
  organization_id: string;
  title: string;
  description: string | null;
  status: string;
  amount: number | null;
  closedby: string | null;
  connecttoclients: string | null;
  created_by: string | null;
  created_at: string | null;
  updated_at: string | null;
  name: string | null;
  phone: string | null;
  first_name: string | null;
  last_name: string | null;
}

interface Client {
  id: string;
  first_name?: string;
  last_name?: string;
}

export default defineComponent({
  name: 'DealsTable',
  components: {
    Pagination
  },
  setup() {
    const stateStoreInstance = stateStore;
    const router = useRouter();
    const { locale } = useI18n();
    const deals = ref<Deal[]>([]);
    const loading = ref(true);
    const searchTerm = ref('');
    const organizationCurrency = ref('USD'); // Default currency code
    const currencySymbol = ref('$'); // Default currency symbol
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };

    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    // Formatting functions
    const formatCurrency = (value: number | null): string => {
      if (value === null) return `0.00 ${currencySymbol.value}`;
      
      try {
        // Try to use the standard formatter with currency code
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: organizationCurrency.value,
          minimumFractionDigits: 2
        }).format(value);
      } catch (error) {
        // Fallback if there's an error - use the symbol directly
        console.warn('Error formatting currency:', error);
        return `${value.toFixed(2)} ${currencySymbol.value}`;
      }
    };
    
    const formatDate = (dateString: string | null): string => {
      if (!dateString) return 'N/A';
      
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    };
    
    const shortId = (id: string): string => {
      // Shorten UUID for display
      return id ? '#' + id.split('-')[0] : '';
    };
    
    const getStatusText = (status: string): string => {
      const statusMap: Record<string, string> = {
        'new': directT('crm.deals.statuses.new'),
        'in progress': directT('crm.deals.statuses.inProgress'),
        'negotiation': directT('crm.deals.statuses.negotiation'),
        'closed won': directT('crm.deals.statuses.closedWon'),
        'closed lost': directT('crm.deals.statuses.closedLost')
      };
      
      return statusMap[status.toLowerCase()] || status;
    };
    
    // Filter deals by search term
    const filteredDeals = computed(() => {
      if (!searchTerm.value.trim()) {
        return deals.value;
      }
      
      const term = searchTerm.value.toLowerCase();
      return deals.value.filter(deal => 
        deal.title?.toLowerCase().includes(term) || 
        deal.description?.toLowerCase().includes(term) ||
        deal.name?.toLowerCase().includes(term) ||
        (deal.first_name && deal.first_name.toLowerCase().includes(term)) ||
        (deal.last_name && deal.last_name.toLowerCase().includes(term))
      );
    });
    
    // Load all deals
    const fetchDeals = async () => {
      try {
        loading.value = true;
        console.log('Starting to fetch deals...');
        
        // Get current user organization ID
        const { data: userData, error: userError } = await supabase.auth.getUser();
        if (userError) {
          console.error('Error getting user:', userError);
          throw userError;
        }
        
        console.log('User data:', userData);
        
        if (!userData.user) {
          console.error('No user found in auth data');
          createToast('User is not authenticated', 'error');
          loading.value = false;
          return;
        }
        
        console.log('User ID:', userData.user.id);
        
        // Get user profile with organization ID
        const { data: profileData, error: profileError } = await supabase
          .from('user_profiles')
          .select('org_id')
          .eq('user_id', userData.user.id)
          .single();
          
        if (profileError) {
          console.error('Error getting user profile:', profileError);
          throw profileError;
        }
        
        console.log('Profile data:', profileData);
        
        if (!profileData || !profileData.org_id) {
          console.error('No organization ID found in user profile');
          createToast('User profile has no organization ID', 'error');
          loading.value = false;
          return;
        }
        
        const organizationId = profileData.org_id;
        console.log('Organization ID:', organizationId);
        
        // Fetch organization details to get currency
        const { data: orgData, error: orgError } = await supabase
          .from('organizations')
          .select('currency')
          .eq('id', organizationId)
          .single();
          
        if (!orgError && orgData && orgData.currency && typeof orgData.currency === 'string') {
          const currencyValue = orgData.currency.trim();
          console.log('Organization currency value:', currencyValue);
          
          // Check if it's a standard 3-letter currency code
          const isStandardCode = /^[A-Z]{3}$/i.test(currencyValue);
          
          if (isStandardCode) {
            // It's a standard code like USD, EUR, ILS
            organizationCurrency.value = currencyValue.toUpperCase();
            currencySymbol.value = getCurrencySymbol(organizationCurrency.value);
            console.log('Using standard currency code:', organizationCurrency.value, 'with symbol:', currencySymbol.value);
          } else {
            // It's probably a symbol like $, €, ₪, etc.
            currencySymbol.value = currencyValue;
            
            // Try to map the symbol to a currency code
            const knownSymbols: Record<string, string> = {
              '$': 'USD',
              '€': 'EUR',
              '£': 'GBP',
              '¥': 'JPY',
              '₽': 'RUB',
              '₹': 'INR',
              '₪': 'ILS',
            };
            
            organizationCurrency.value = knownSymbols[currencyValue] || 'USD';
            console.log('Using currency symbol:', currencySymbol.value, 'with code:', organizationCurrency.value);
          }
        } else {
          console.warn('Could not fetch organization currency, using default:', organizationCurrency.value);
          if (orgError) console.error('Organization fetch error:', orgError);
        }
        
        // Let's try a debug query to see all deals regardless of organization
        const { data: debugAllDeals, error: debugError } = await supabase
          .from('deals')
          .select('id, title, organization_id')
          .limit(10);
          
        console.log('DEBUG - All deals in system:', debugAllDeals, debugError);
        
        // Try a direct query with raw SQL to bypass any potential ORM issues
        const { data: rawSqlDeals, error: rawSqlError } = await supabase
          .rpc('get_deals_by_org', { org_id: organizationId });
          
        console.log('DEBUG - Raw SQL query result:', rawSqlDeals, rawSqlError);
        
        // Let's try a direct query first to see if any deals exist for this organization
        const { data: dealsCheck, error: dealsCheckError } = await supabase
          .from('deals')
          .select('id, title, organization_id')
          .eq('organization_id', organizationId)
          .limit(5);
          
        if (dealsCheckError) {
          console.error('Error checking deals existence:', dealsCheckError);
        } else {
          console.log('Deals check (first 5):', dealsCheck);
          console.log('Deals check SQL query:', (dealsCheck as any)?._query?.[0]?.query);
        }
        
        // Load deals with related client details
        console.log('Fetching deals with client details...');
        // Using basic query without JOIN to avoid TS errors 
        const { data, error } = await supabase
          .from('deals')
          .select('*')
          .eq('organization_id', organizationId)
          .order('created_at', { ascending: false });
          
        if (error) {
          console.error('Error fetching deals with client details:', error);
          throw error;
        }
        
        console.log('Deals data from API:', data);
        
        // Convert data to the structure we need
        if (data && data.length > 0) {
          console.log('Processing', data.length, 'deals');
          
          // If we need client data, we'll fetch it separately
          const clientIds = data
            .filter(deal => deal.connecttoclients)
            .map(deal => deal.connecttoclients);
            
          let clientsMap: Record<string, { first_name?: string, last_name?: string }> = {};
          
          if (clientIds.length > 0) {
            console.log('Fetching client data for', clientIds.length, 'clients');
            const { data: clientsData, error: clientsError } = await supabase
              .from('clients')
              .select('id, first_name, last_name')
              .in('id', clientIds);
              
            if (!clientsError && clientsData) {
              clientsMap = (clientsData as Client[]).reduce((acc, client) => {
                const clientId = client.id;
                acc[clientId] = {
                  first_name: client.first_name,
                  last_name: client.last_name
                };
                return acc;
              }, {} as Record<string, { first_name?: string, last_name?: string }>);
            }
          }
          
          deals.value = data.map((deal: any) => {
            let first_name = null;
            let last_name = null;
            
            // If this deal has a client, get the client data from our map
            if (deal.connecttoclients && clientsMap[deal.connecttoclients]) {
              first_name = clientsMap[deal.connecttoclients].first_name || null;
              last_name = clientsMap[deal.connecttoclients].last_name || null;
            }
            
            return {
              ...deal,
              first_name,
              last_name
            };
          }) as Deal[];
          console.log('Processed deals:', deals.value);
        } else {
          console.log('No deals found or data is empty');
          deals.value = [];
        }
        
      } catch (error) {
        console.error('Error loading deals:', error);
        createToast('Error loading deals', 'error');
      } finally {
        loading.value = false;
      }
    };
    
    // Functions for deal actions
    const viewDeal = (id: string) => {
      console.log('View deal:', id);
      router.push(`/crm/deals/${id}`);
    };
    
    const editDeal = (id: string) => {
      console.log('Edit deal:', id);
      router.push(`/crm/deals/${id}`);
    };
    
    const confirmDeleteDeal = (id: string) => {
      if (confirm('Are you sure you want to delete this deal?')) {
        deleteDeal(id);
      }
    };
    
    const deleteDeal = async (id: string) => {
      try {
        const { error } = await supabase
          .from('deals')
          .delete()
          .eq('id', id);
          
        if (error) throw error;
        
        // Remove the deal from the list
        deals.value = deals.value.filter(deal => deal.id !== id);
        createToast('Deal deleted successfully', 'success');
      } catch (error) {
        console.error('Error deleting deal:', error);
        createToast('Error deleting deal', 'error');
      }
    };
    
    // Add an alternative loading method to bypass organization check
    const fetchAllDeals = async () => {
      try {
        loading.value = true;
        console.log('Attempting to fetch all deals without org filter...');
        
        // Simple query without relations to avoid TS errors
        const { data, error } = await supabase
          .from('deals')
          .select('*')
          .order('created_at', { ascending: false })
          .limit(100);
          
        if (error) {
          console.error('Error in alternative deals loading:', error);
          throw error;
        }
        
        console.log('All deals data (alternative method):', data);
        
        if (data && data.length > 0) {
          console.log('Found', data.length, 'deals with alternative method');
          
          // If we need client data, fetch it separately
          const clientIds = data
            .filter(deal => deal.connecttoclients)
            .map(deal => deal.connecttoclients);
            
          let clientsMap: Record<string, { first_name?: string, last_name?: string }> = {};
          
          if (clientIds.length > 0) {
            const { data: clientsData, error: clientsError } = await supabase
              .from('clients')
              .select('id, first_name, last_name')
              .in('id', clientIds);
              
            if (!clientsError && clientsData) {
              clientsMap = (clientsData as Client[]).reduce((acc, client) => {
                const clientId = client.id;
                acc[clientId] = {
                  first_name: client.first_name,
                  last_name: client.last_name
                };
                return acc;
              }, {} as Record<string, { first_name?: string, last_name?: string }>);
            }
          }
          
          deals.value = data.map((deal: any) => {
            let first_name = null;
            let last_name = null;
            
            if (deal.connecttoclients && clientsMap[deal.connecttoclients]) {
              first_name = clientsMap[deal.connecttoclients].first_name || null;
              last_name = clientsMap[deal.connecttoclients].last_name || null;
            }
            
            return {
              ...deal,
              first_name,
              last_name
            };
          }) as Deal[];
          
          createToast('Loaded deals with alternative method', 'success');
        } else {
          console.log('No deals found with alternative method');
          createToast('No deals found in the system', 'error');
        }
      } catch (error) {
        console.error('Alternative loading failed:', error);
        createToast('Failed to load deals', 'error');
      } finally {
        loading.value = false;
      }
    };
    
    // Debug function to check database tables and connection
    const checkTablesAndDebugging = async () => {
      try {
        loading.value = true;
        console.log('Starting debugging process...');
        
        // 1. Check if user is authenticated
        const { data: authData, error: authError } = await supabase.auth.getUser();
        console.log('Auth check:', authData, authError);
        
        if (authError) {
          createToast('Authentication error: ' + authError.message, 'error');
          return;
        }
        
        if (!authData.user) {
          createToast('Not authenticated', 'error');
          return;
        }
        
        // 2. Get list of tables to confirm database connection
        const { data: tablesData, error: tablesError } = await supabase
          .from('deals')
          .select('id')
          .limit(1);
          
        console.log('Tables check:', tablesData, tablesError);
        
        if (tablesError) {
          createToast('Cannot access deals table: ' + tablesError.message, 'error');
        } else {
          createToast('Successfully connected to deals table', 'success');
        }
        
        // 3. Check if the user has an organization
        const { data: profileData, error: profileError } = await supabase
          .from('user_profiles')
          .select('*')
          .eq('user_id', authData.user.id);
          
        console.log('User profile check:', profileData, profileError);
        
        if (profileError) {
          createToast('Error accessing user profile: ' + profileError.message, 'error');
        } else if (!profileData || profileData.length === 0) {
          createToast('User profile not found', 'error');
        } else {
          const orgId = profileData[0]?.org_id;
          if (orgId) {
            createToast('Found organization ID: ' + orgId, 'success');
            
            // 4. Check if there are deals for this org
            const { data: orgDeals, error: orgDealsError } = await supabase
              .from('deals')
              .select('id')
              .eq('organization_id', orgId);
              
            console.log('Org deals check:', orgDeals, orgDealsError);
            
            if (orgDealsError) {
              createToast('Error checking org deals: ' + orgDealsError.message, 'error');
            } else if (orgDeals) {
              createToast(`Found ${orgDeals?.length || 0} deals for this organization`, 'info');
            }
          } else {
            createToast('User has no organization ID', 'error');
          }
        }
        
        // 5. Check overall database state
        console.log('Debug process completed');
        
      } catch (error) {
        console.error('Debug process error:', error);
        createToast('Debug process failed', 'error');
      } finally {
        loading.value = false;
      }
    };
    
    // Function to create a test deal for debugging
    const createTestDeal = async () => {
      try {
        loading.value = true;
        console.log('Creating a test deal record...');
        
        // Get organization ID
        const { data: userData } = await supabase.auth.getUser();
        if (!userData?.user) {
          createToast('Not authenticated', 'error');
          return;
        }
        
        const { data: profileData } = await supabase
          .from('user_profiles')
          .select('org_id')
          .eq('user_id', userData.user.id)
          .single();
          
        if (!profileData?.org_id) {
          createToast('No organization ID found', 'error');
          return;
        }
        
        const organizationId = profileData.org_id;
        
        // Create a new deal
        const { data: newDeal, error: createError } = await supabase
          .from('deals')
          .insert([
            {
              title: 'Test Deal ' + new Date().toISOString(),
              description: 'Created for testing from the UI',
              organization_id: organizationId,
              status: 'new',
              amount: 5000,
              name: 'Test Contact',
              created_by: userData.user.id
            }
          ])
          .select();
          
        if (createError) {
          console.error('Error creating test deal:', createError);
          createToast('Failed to create test deal: ' + createError.message, 'error');
        } else if (newDeal) {
          console.log('Successfully created test deal:', newDeal);
          createToast('Test deal created successfully!', 'success');
          // Refresh deals list
          fetchDeals();
        }
      } catch (error) {
        console.error('Error in create test deal:', error);
        createToast('Error creating test deal', 'error');
      } finally {
        loading.value = false;
      }
    };
    
    // Helper to get currency symbol from code
    const getCurrencySymbol = (currencyCode: string): string => {
      // Create a formatter for the currency
      try {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
        });
        
        // Extract just the symbol
        const parts = formatter.formatToParts(0);
        const symbolPart = parts.find(part => part.type === 'currency');
        return symbolPart ? symbolPart.value : currencyCode;
      } catch (error) {
        console.warn('Error getting currency symbol:', error);
        return currencyCode;
      }
    };
    
    onMounted(fetchDeals);

    return {
      stateStoreInstance,
      deals,
      loading,
      searchTerm,
      filteredDeals,
      formatCurrency,
      formatDate,
      shortId,
      getStatusText,
      viewDeal,
      editDeal,
      confirmDeleteDeal,
      fetchAllDeals,
      checkTablesAndDebugging,
      createTestDeal,
      directT
    };
  }
});
</script>

<style scoped>
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
